import React, { ReactNode } from 'react';
import { approvePayout } from '../../api/requests';
import Button from '../../components/form-control/Button';
import { Payout } from '../../models/payout/Payout';
import { PAYOUT_REVIEW_STATES } from '../../resources/enums';
import { formatCurrencyAmount } from '../../utils/miscFunctions';
import { showToast } from '../../utils/miscFunctions';

interface IPayoutReviewProps {
  payout: Payout;
  onProceed: (data: Payout) => void;
  onCancel: () => void;
  type: PAYOUT_REVIEW_STATES;
  title: string;
  titleIcon?: ReactNode | JSX.Element;
}

const ApprovePayout = (props: IPayoutReviewProps) => {
  const [submitting, setSubmitting] = React.useState<boolean>(false);
 
  const handleSubmit = () => {
    setSubmitting(true);

    if (props.type === PAYOUT_REVIEW_STATES.APPROVE) {
      approvePayout(props.payout.id)
        .then((response: any) => {
          props.onProceed(props.payout);
          showToast.success(response.message);
        })
        .catch((error: any) => {
          showToast.error(error.description);
        })
        .finally(() => setSubmitting(false));
    }
  };

  const getDescription = (): string => {
    switch (props.type) {
      case PAYOUT_REVIEW_STATES.APPROVE:
        return 'Do you approve this payout?';
      default:
        return '';
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden w-full max-w-md mx-auto">
      <div className="p-6">
        <div className="text-center mb-6">
          {props.titleIcon && (
            <div className="mx-auto w-12 h-12 flex items-center justify-center rounded-full bg-blue-50 mb-4">
              {props.titleIcon}
            </div>
          )}
          <h3 className="text-lg font-medium text-gray-900 mb-2">{props.title}</h3>
          <p className="text-gray-600">{getDescription()}</p>
        </div>

        <div className="bg-gray-50 p-4 rounded-lg mb-6">
          <div className="flex flex-col items-center">
            <span className="text-sm font-medium text-gray-500 mb-1">Amount to Pay</span>
            <div className="flex items-baseline space-x-1">
              <span className="ml-2 text-gray-500">{props.payout?.currency || 'GHC'}</span>
              <span className="text-2xl font-bold text-gray-900">
               {formatCurrencyAmount(props?.payout?.grossToPay)}
              </span>
            </div>
          </div>
        </div>


        <div className="w-full flex gap-4 ">
          <Button
            label="Cancel"
            bgColor='secondary'
                  fullWidth
            onClick={props.onCancel}
          />
          <Button
            label="Confirm"
            onClick={handleSubmit}
            bgColor='primary'
              fullWidth
            loading={submitting}
            disabled={submitting}
          />
        </div>
      </div>
    </div>
  );
};

export default ApprovePayout;
